class Drawer {
  constructor() {
    this.drawers = document.querySelectorAll('.drawer');
    this.activeDrawer = null;
    this.previousActiveElement = null;
    this.init();
  }

  init() {
    // Manejador para abrir drawers mediante data attributes
    document.addEventListener('click', (event) => {
      const toggleButton = event.target.closest('[data-drawer-toggle]');
      if (toggleButton) {
        event.preventDefault();
        const drawerId = toggleButton.getAttribute('data-drawer-toggle');
        const position = toggleButton.getAttribute('data-drawer-position') || 'right';
        this.openDrawer(drawerId, position);
      }
    });

    // Manejador para eventos personalizados de apertura de drawer
    document.addEventListener('openDrawer', (event) => {
      const { drawerId, position = 'right' } = event.detail;
      this.openDrawer(drawerId, position);
    });

    // Manejador para cerrar drawers
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('drawer-overlay') || 
          event.target.closest('.js-drawer-close')) {
        event.preventDefault();
        this.closeAllDrawers();
      }
    });

    // Cerrar con la tecla ESC
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.closeAllDrawers();
      }
    });

    // Prevenir scroll en el body cuando el drawer está abierto
    this.drawers.forEach(drawer => {
      drawer.addEventListener('transitionend', () => {
        if (drawer.getAttribute('aria-hidden') === 'true') {
          document.body.style.overflow = '';
        }
      });
    });

    // Manejador para cerrar al hacer clic en el overlay
    document.addEventListener('click', (event) => {
      if (event.target.matches('.drawer-overlay')) {
        const drawerId = event.target.getAttribute('data-drawer-overlay');
        this.closeDrawer(drawerId);
      }
    });
  }

  openDrawer(drawerId, position) {
    const drawer = document.querySelector(`[data-drawer-id="${drawerId}"]`);
    const overlay = document.querySelector(`[data-drawer-overlay="${drawerId}"]`);
    
    if (drawer) {
      this.closeAllDrawers();
      
      this.previousActiveElement = document.activeElement;
      
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('data-position', position);
      drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('drawer-open');
      this.activeDrawer = drawer;

      overlay.classList.add('active');
      
      drawer.classList.remove('drawer--left', 'drawer--right');
      drawer.classList.add(`drawer--${position}`);

      // Emit drawer open event for header scroll controller
      const drawerOpenEvent = new CustomEvent('drawerOpen', {
        detail: { drawerId, position }
      });
      document.dispatchEvent(drawerOpenEvent);
    }
  }

  closeDrawer(drawerId) {
    const drawer = document.querySelector(`[data-drawer-id="${drawerId}"]`);
    const overlay = document.querySelector(`[data-drawer-overlay="${drawerId}"]`);
    
    if (drawer) {
      const focusedElement = document.activeElement;
      if (drawer.contains(focusedElement)) {
        const toggleButton = document.querySelector(`[data-drawer-toggle="${drawerId}"]`);
        if (toggleButton) {
          toggleButton.focus();
        } else if (this.previousActiveElement) {
          this.previousActiveElement.focus();
        }
      }
      
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-open');
      this.activeDrawer = null;

      // Emit drawer close event for header scroll controller
      const drawerCloseEvent = new CustomEvent('drawerClose', {
        detail: { drawerId }
      });
      document.dispatchEvent(drawerCloseEvent);
    }
  }

  closeAllDrawers() {
    this.drawers.forEach(drawer => {
      const drawerId = drawer.getAttribute('data-drawer-id');
      this.closeDrawer(drawerId);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Drawer();
});